(function () {
  var canvas = document.getElementById('moleculeCanvas');
  if (!canvas || typeof THREE === 'undefined') return;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var container = canvas.parentElement;

  var renderer;
  try {
    renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true });
  } catch (e) {
    return; // WebGL not supported — leave the container empty rather than break the page
  }
  renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));

  var scene = new THREE.Scene();
  var camera = new THREE.PerspectiveCamera(42, 1, 0.1, 100);
  camera.position.set(0, 0, 6.4);

  function sizeToContainer() {
    var w = container.clientWidth || 400;
    var h = container.clientHeight || 400;
    renderer.setSize(w, h, false);
    camera.aspect = w / h;
    camera.updateProjectionMatrix();
  }

  // ---------- Lights ----------
  scene.add(new THREE.AmbientLight(0xffffff, 0.6));

  var keyLight = new THREE.PointLight(0xffffff, 1.5, 20);
  keyLight.position.set(-3, 3, 4);
  scene.add(keyLight);

  var fillLight = new THREE.PointLight(0x5b8def, 1.3, 20);
  fillLight.position.set(3, -2, 3);
  scene.add(fillLight);

  var rimLight = new THREE.PointLight(0x7fe0a8, 0.8, 20);
  rimLight.position.set(0, -3, -3);
  scene.add(rimLight);

  // ---------- Molecule group ----------
  var moleculeGroup = new THREE.Group();
  scene.add(moleculeGroup);

  var baseSphereMaterial = new THREE.MeshPhysicalMaterial({
    metalness: 0.05,
    roughness: 0.1,
    clearcoat: 1,
    clearcoatRoughness: 0.06,
    transmission: 0.4,
    thickness: 0.6,
    transparent: true,
    opacity: 0.97,
    emissive: 0x0d1b2a,
    emissiveIntensity: 0.35
  });

  var bondMaterial = new THREE.MeshStandardMaterial({
    color: 0x1b3a5c,
    metalness: 0.15,
    roughness: 0.35,
    transparent: true,
    opacity: 0.6
  });

  // Brand palette cycled across the chain: accent blue, accent-2 light blue, secondary green
  var palette = [0x5b8def, 0x9ac8ff, 0x7fe0a8, 0x5b8def, 0x9ac8ff, 0x7fe0a8, 0x5b8def, 0x9ac8ff, 0x5b8def];

  var atoms = [
    { p: [-2.0, 0.6, 0.1], r: 0.26, c: palette[0] },
    { p: [-1.5, 0.78, -0.1], r: 0.32, c: palette[1] },
    { p: [-1.7, -0.1, 0.15], r: 0.4, c: palette[2] },
    { p: [-0.9, -0.45, 0.0], r: 0.5, c: palette[3] },
    { p: [-0.15, 0.18, 0.2], r: 0.56, c: palette[4] },
    { p: [0.55, -0.5, -0.1], r: 0.5, c: palette[5] },
    { p: [1.05, 0.35, 0.1], r: 0.44, c: palette[6] },
    { p: [1.65, 0.68, -0.15], r: 0.4, c: palette[7] },
    { p: [1.8, -0.32, 0.05], r: 0.28, c: palette[8] }
  ];

  var bonds = [[0,1],[1,2],[2,3],[3,4],[4,5],[5,6],[6,7],[7,8]];

  var atomMeshes = atoms.map(function (a) {
    var mat = baseSphereMaterial.clone();
    mat.color.setHex(a.c);
    var geo = new THREE.SphereGeometry(a.r, 32, 32);
    var mesh = new THREE.Mesh(geo, mat);
    mesh.position.set(a.p[0], a.p[1], a.p[2]);
    moleculeGroup.add(mesh);
    return mesh;
  });

  function makeBond(p1, p2) {
    var v1 = new THREE.Vector3(p1[0], p1[1], p1[2]);
    var v2 = new THREE.Vector3(p2[0], p2[1], p2[2]);
    var dir = new THREE.Vector3().subVectors(v2, v1);
    var len = dir.length();
    var geo = new THREE.CylinderGeometry(0.07, 0.07, len, 10, 1, false);
    var mesh = new THREE.Mesh(geo, bondMaterial);
    mesh.position.copy(v1).add(v2).multiplyScalar(0.5);
    mesh.quaternion.setFromUnitVectors(new THREE.Vector3(0, 1, 0), dir.clone().normalize());
    return mesh;
  }

  bonds.forEach(function (pair) {
    moleculeGroup.add(makeBond(atoms[pair[0]].p, atoms[pair[1]].p));
  });

  // ---------- Orbit rings ----------
  function makeRing(rx, ry, color, opacity, tiltX, tiltZ) {
    var curve = new THREE.EllipseCurve(0, 0, rx, ry, 0, Math.PI * 2, false, 0);
    var pts = curve.getPoints(96).map(function (p) { return new THREE.Vector3(p.x, p.y, 0); });
    var geo = new THREE.BufferGeometry().setFromPoints(pts);
    var mat = new THREE.LineBasicMaterial({ color: color, transparent: true, opacity: opacity });
    var ring = new THREE.LineLoop(geo, mat);
    ring.rotation.x = tiltX;
    ring.rotation.z = tiltZ;
    return ring;
  }

  var ringA = makeRing(2.7, 1.0, 0x9ac8ff, 0.55, 0.35, 0.12);
  var ringB = makeRing(2.5, 0.85, 0x7fe0a8, 0.4, -0.25, -0.08);
  moleculeGroup.add(ringA);
  moleculeGroup.add(ringB);

  // ---------- Floating particles ----------
  var particleMaterial = new THREE.MeshBasicMaterial({ color: 0xbfe0ff, transparent: true, opacity: 0.9 });
  var particles = [];
  var particlePositions = [
    [-2.4, 1.4, 0.3], [2.3, 1.1, -0.2], [2.6, -0.9, 0.4],
    [-2.6, -0.7, -0.3], [0.2, 1.6, 0.5], [-0.6, -1.4, -0.4]
  ];
  particlePositions.forEach(function (p, i) {
    var geo = new THREE.SphereGeometry(0.045 + (i % 2) * 0.02, 10, 10);
    var mesh = new THREE.Mesh(geo, particleMaterial);
    mesh.position.set(p[0], p[1], p[2]);
    moleculeGroup.add(mesh);
    particles.push(mesh);
  });

  // ---------- Resize handling ----------
  sizeToContainer();
  window.addEventListener('resize', sizeToContainer, { passive: true });
  if ('ResizeObserver' in window) {
    new ResizeObserver(sizeToContainer).observe(container);
  }

  // ---------- Animation ----------
  var clock = new THREE.Clock();

  function renderFrame() {
    var t = clock.getElapsedTime();
    moleculeGroup.rotation.y = t * 0.22;
    moleculeGroup.rotation.x = Math.sin(t * 0.3) * 0.08;
    moleculeGroup.position.y = Math.sin(t * 0.6) * 0.08;
    ringA.rotation.z += 0.0009;
    ringB.rotation.z -= 0.0012;
    particles.forEach(function (p, i) {
      p.position.y += Math.sin(t * 0.8 + i) * 0.0008;
    });
    renderer.render(scene, camera);
  }

  if (prefersReducedMotion) {
    renderFrame();
  } else {
    (function animate() {
      requestAnimationFrame(animate);
      renderFrame();
    })();
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { clock.stop(); } else { clock.start(); }
  });
})();
